export default "__VITE_ASSET__D2T6WiDd__"